// ⚠ MOCK ONLY — Assign and Edit shift on the demo calendar change THIS list,
// held in page state, and nothing else. No request is sent; a reload forgets.
//
// Each edit is applied on top of the source in order, so Undo is simply
// dropping one edit and the source is never mutated. When the real actions
// arrive (an existing assign endpoint; a schedule draft + publish for a shift,
// see B5) the page calls those instead and refetches — this file goes.

import type { CalendarSource, MinuteSpan } from "./calendar-board";
import { dayStartIso } from "./calendar-model";

export type MockEdit =
  | { id: string; kind: "assign"; bookingId: string; therapistId: string }
  /** `shift: null` sets a day off. */
  | {
      id: string;
      kind: "shift";
      staffId: string;
      day: string;
      shift: MinuteSpan | null;
    };

function isoAt(day: string, minutes: number): string {
  return new Date(Date.parse(dayStartIso(day)) + minutes * 60_000).toISOString();
}

export function applyMockEdits(source: CalendarSource, edits: readonly MockEdit[]): CalendarSource {
  if (edits.length === 0) return source;
  let { staff, bookings } = source.models;
  for (const edit of edits) {
    if (edit.kind === "assign") {
      bookings = bookings.map((booking) =>
        booking.bookingId === edit.bookingId
          ? {
              ...booking,
              therapistId: edit.therapistId,
              status: booking.status === "awaiting_therapist" ? "pending" : booking.status,
            }
          : booking,
      );
    } else {
      staff = staff.map((entry) =>
        entry.staffId === edit.staffId && entry.scheduleDate === edit.day
          ? {
              ...entry,
              kind: edit.shift ? "duty" : "rest_day",
              dutyStart: edit.shift ? isoAt(edit.day, edit.shift.startMin) : null,
              dutyEnd: edit.shift ? isoAt(edit.day, edit.shift.endMin) : null,
            }
          : entry,
      );
    }
  }
  return { ...source, models: { ...source.models, staff, bookings } };
}

export function withoutEdit(edits: readonly MockEdit[], id: string): MockEdit[] {
  return edits.filter((edit) => edit.id !== id);
}

/** Half-hour steps for the shift pickers, 6 AM to 2 AM the next day. */
export function shiftTimeOptions(): number[] {
  return Array.from({ length: 41 }, (_, index) => 6 * 60 + index * 30);
}
